import { getDashboardPageExtensionsDir } from '@wix/cli-astro-definitions';
import {
  composeValidations,
  pathAvailableValidation,
  pathValidation,
} from './common.js';

export function createDashboardRouteValidation(projectFolder: string) {
  return composeValidations([
    [
      pathAvailableValidation(getDashboardPageExtensionsDir(projectFolder)),
      'The page route must be unique, please choose a route that has not been used yet in your application.',
    ],
    [
      pathValidation,
      'The page route must be a valid URL path ([a-z0-9-/]+) and must not start with a dot.',
    ],
  ]);
}
